import { apiGet, apiPatch, apiPost, getFreshToken } from '../../utilities/apiClient';
import { UPDATE_USER } from '../constants';
import { getStoreState } from './_sessionIds';

export const fetchUser = (cognitoId: string, accountId: string) => async (dispatch: any) => {
  try {
    const response = await apiGet(`/users/get-user/${accountId}/${cognitoId}`);
    if (response?.success && response.payload) {
      dispatch({ type: UPDATE_USER, payload: response.payload });
      return { success: true, payload: response.payload };
    }
    return { success: false };
  } catch (err: any) {
    return { success: false, message: err?.message };
  }
};

export const resetUserPassword = (email: string) => async () => {
  const state = getStoreState();
  const accountId = state.session.account?.account_id;
  const cognitoId = state.authentication.user?.cognito_id;
  try {
    const response = await apiPost(`/users/reset-password/${accountId}/${cognitoId}`, { email });
    return { success: !!response?.success, message: response?.message };
  } catch (err: any) {
    return { success: false, message: err?.message || 'Failed to send password reset' };
  }
};

// The token's clientId and channel grants belong to one account, so the Ably
// client asks for the account it is bound to rather than whichever is current.
export const getAblyToken = async (accountId: string): Promise<{ success: boolean; payload?: { token: string }; message?: string }> => {
  const state = getStoreState();
  const cognitoId = state.authentication.user?.cognito_id;
  if (!accountId || !cognitoId) {
    return { success: false, message: 'Account data not yet loaded' };
  }
  try {
    const token = await getFreshToken();
    if (!token) return { success: false, message: 'No valid auth token' };
    const response = await apiGet(`/users/get-ably-token/${accountId}/${cognitoId}`);
    if (response?.payload?.token) return { success: true, payload: response.payload };
    return { success: false, message: response?.message || 'No token in response' };
  } catch (err: any) {
    return { success: false, message: err?.message || 'Failed to fetch Ably token' };
  }
};

export const updateUser = (updates: Record<string, any>) => async (dispatch: any) => {
  const state = getStoreState();
  const accountId = state.session.account?.account_id;
  const cognitoId = state.authentication.user?.cognito_id;
  try {
    const response = await apiPatch(`/users/update/${accountId}/${cognitoId}`, { updates });
    if (response?.success) {
      dispatch({ type: UPDATE_USER, payload: response.payload });
      return { success: true, payload: response.payload };
    }
    return { success: false, message: response?.message || 'Update failed' };
  } catch (err: any) {
    return { success: false, message: err?.message || 'Update failed' };
  }
};
